/* RESPONSIBLE TEAM: team-standalone  */

import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import { isBlank } from '@ember/utils';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class RequestAccessRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;
  @service declare modelDataCacheService: any;
  @service declare appService: any;

  async beforeModel(_transition: Transition) {
    let app = this.appService.app;
    let currentAdmin = app.currentAdmin;

    await Promise.all([
      this.finStandaloneService.loadBasePlatformConfigs(),
      this.modelDataCacheService.awaitRefreshedModel('admin', currentAdmin.id),
    ]);

    if (isBlank(currentAdmin.currentAppPermissions.role_id) || currentAdmin.canAccessReporting) {
      // Both Full Access and Limited Access admins have can access reporting permissions
      // No Access admins do not have access to reporting permissions
      this.router.replaceWith('apps.app', app.id);
    }
  }
}
